
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pools",
      function () {
        return require("private-next-pages/pools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pools"])
      });
    }
  